import React from 'react';
import { Box, Grid, KeyValue, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';
import SchoolInfoTable from '../SchoolInfoTable';
import { useStyles } from './style';

interface SchoolDetail {
  schoolName: string;
  typeOfSchool: string;
  country: string;
  dateOfAdmission: string;
  dateOfCompletion: string;
  highestLevelPassed: string;
}

interface SchoolDetailsProps {
  schoolDetails: SchoolDetail[];
  isAEIS: boolean;
}

const SchoolDetails = (props: SchoolDetailsProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { schoolDetails, isAEIS } = props;

  return (
      <Box className={classes.schoolContainer}>
      {isAEIS && (
      <Grid container spacing={2}>
        <Grid md={12} xs={12}>
          <Typography variant="h3" className={classes.tableTitle}>
            {t('exam->>NonNationalExam.SchoolInfo')}
          </Typography>
          <KeyValue
            keyText={
              isAEIS
                ? t('exam->>NonNationalExam.IsStudyingInSingapore')
                : t('exam->>NonNationalExam.AreYouCurrentlyStudying')
            }
            valueText={
              schoolDetails.length
                ? t('exam->>NonNationalExam.Yes')
                : t('exam->>NonNationalExam.No')
            }
            capitalize={false}
          />
        </Grid>
      </Grid> )}
      {schoolDetails.length > 0 && <SchoolInfoTable isShowAction={false} data={schoolDetails} />}
    </Box>
  );
};
export default SchoolDetails;
